import { useEffect, useMemo, useState } from "react"
import TreeAPI from "../../apis/TreeAPI";
import produce from "immer";
import { GetLevelsAllowedByUser } from "../../apis/User/indexv2";

const usePurchases = (props: IUseCompletedProps) => {

    const [lastReloadDate, setLastRealoadDate] = useState<Date>(new Date());
    const [purchasesWithTimer, setPurchasesWithTimer] = useState<{
        [episodeId: string]: true | undefined
    }>({});

    const [purchasesWithCode, setPurchasesWithCode] = useState<{
        [episodeId: string]: true | undefined;
    }>({});

    useEffect(() => {
        setPurchasesWithCode({});
        if (props.userId === undefined) return;
        const unsubscribe = TreeAPI.subscribeToPurchases(
            props.userId,
            (data: IDBRealtimePurchase) => {
                setPurchasesWithCode(
                    produce(draft => {
                        const episodeIds = Object.keys(data);

                        for (let index = 0; index < episodeIds.length; index++) {
                            const episodeId = episodeIds[index];

                            if (data[episodeId] === true)
                                draft[episodeId] = true;
                        }
                    })
                );
            }
        );
        return () => unsubscribe();
    }, [props.userId]);

    useEffect(() => {
        setPurchasesWithTimer({});
        if (props.userId === undefined) return;
        const controller = new AbortController();
        GetLevelsAllowedByUser(props.userId, controller)
            .then(episodeIds => {
                setPurchasesWithTimer(
                    produce(draft => {
                        for (let index = 0; index < episodeIds.length; index++) {
                            const episodeId = episodeIds[index];
                            draft[episodeId] = true;
                        }
                    })
                );
            }).catch((error) => { });
        return () => {
            controller.abort();
        };
    }, [props.userId, lastReloadDate]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setLastRealoadDate(new Date());
        }, 1000 * 60 * 60);

        return () => clearInterval(intervalId);
    }, []);

    const purchases = useMemo(() => {
        return {
            ...purchasesWithCode,
            ...purchasesWithTimer
        };
    }, [purchasesWithTimer, purchasesWithCode]);

    const purchasesArray = useMemo(() => {
        const episodeIds = Object.keys(purchases);

        const array: string[] = [];

        for (let index = 0; index < episodeIds.length; index++) {
            const episodeId = episodeIds[index];
            if (purchases[episodeId] === true)
                array.push(episodeId);
        }

        return array;
    }, [purchases]);

    return { purchases, purchasesArray };
}

export { usePurchases }